var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { accountApi } from '../../api/common/account';
import { ERR_GENERIC, ERR_PRICING_BOOK } from '../../constants';
var RewardsAndOffersContext = React.createContext(null);
var RewardsAndOffersProvider = function (_a) {
    var children = _a.children;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(null), generalError = _c[0], setGeneralError = _c[1];
    var _d = useState(null), rewardsAndOffers = _d[0], setRewardsAndOffers = _d[1];
    var _e = useState(false), isChildAccount = _e[0], setIsChildAccount = _e[1];
    var isChildAccountEnabled = ['1', 1].includes(useConfigService('ENABLE_CHILD_ACCOUNT_CHANGES'));
    var isSquareBenefitsEnabled = ['1', 1].includes(useConfigService('ENABLE_SQUARE_BENEFITS'));
    var isPricingBookEnabled = !!useConfigService('ENABLE_NEW_PRICING_BENEFIT_PAGE');
    var enablePath2ProCard = !!useConfigService('fs:ENABLE_PATH_TO_PRO_CARD');
    var enablePartnerOffers = !!useConfigService('fs:ENABLE_PARTNER_OFFERS');
    var topSavingsValue = useConfigService('IS_TOP_SAVINGS');
    var showTopSavingsAtTop = topSavingsValue === 'top';
    var showTopSavingsAtMiddle = topSavingsValue === 'middle';
    var showTopSavingsAtLast = topSavingsValue === 'last';
    var getRewardsAndOffersData = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // Note: options parameter is for future use with AbortSignal
            return [2 /*return*/, accountApi.rewardsAndOffersDetails().then(function (data) {
                    var _a;
                    setRewardsAndOffers(data);
                    setIsChildAccount(((_a = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _a === void 0 ? void 0 : _a.isChildAccount) && isChildAccountEnabled);
                    if (!(data === null || data === void 0 ? void 0 : data.customerInfo)) {
                        var errorMessage = isPricingBookEnabled
                            ? ERR_PRICING_BOOK
                            : ERR_GENERIC;
                        setGeneralError(errorMessage);
                    }
                })];
        });
    }); };
    // const raoModified: any = {
    //   ...rewardsAndOffers,
    //   customerInfo: {
    //     ...rewardsAndOffers?.customerInfo,
    //     // // Test governmentAccount
    //     // enrolledInPerksProgram: false,
    //     // // Test non-preferredPricing
    //     enrolledInPreferredPricing: false,
    //     // // Test Paint Rewards
    //     // paintMembershipLevel: 'Member',
    //     // paintMembershipLevel: 'Bronze',
    //     // paintMembershipLevel: 'Silver',
    //     // paintMembershipLevel: 'Gold',
    //   },
    //   proTiers: {
    //     benefitTags: [
    //       {
    //         tagName: 'eliteCallCenter',
    //         value: '7007338211',
    //       },
    //       // {
    //       //   tagName: 'AMBenefit',
    //       //   value: 'confirmed',
    //       // },
    //       {
    //         tagName: 'AMBenefit',
    //         value: 'eligible',
    //       },
    //     ],
    //   },
    // };
    return (React.createElement(RewardsAndOffersContext.Provider, { value: React.useMemo(function () { return ({
            // rewardsAndOffers: raoModified,
            rewardsAndOffers: rewardsAndOffers,
            isChildAccount: isChildAccount,
            getRewardsAndOffersData: getRewardsAndOffersData,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            generalError: generalError,
            setGeneralError: setGeneralError,
            isSquareBenefitsEnabled: isSquareBenefitsEnabled,
            topSavingsValue: topSavingsValue,
            showTopSavingsAtTop: showTopSavingsAtTop,
            showTopSavingsAtMiddle: showTopSavingsAtMiddle,
            showTopSavingsAtLast: showTopSavingsAtLast,
            enablePath2ProCard: enablePath2ProCard,
            enablePartnerOffers: enablePartnerOffers,
        }); }, [isLoading, topSavingsValue, isSquareBenefitsEnabled]) }, children));
};
export { RewardsAndOffersProvider, RewardsAndOffersContext };
